import cn from 'classnames'
import { Card, CardContent, Typography } from 'components/Material/index'
import useTextStyles from 'styles/useTextStyles'

type Props = {
  isSelected?: boolean
  title?: string
  subtitle?: string
  id?: string
  handleSelect?: () => void
  className?: string
  onClick?: () => void
}

export const LineCard = ({
  title,
  subtitle,
  isSelected = false,
  className,

  handleSelect
}: Props) => {
  return (
    <Card
      className={cn(
        'border cursor-pointer h-[80px] max-w-[800px] border-gray-cac rounded-xl text-light-on-surface  hover:bg-[#e7e0ec]',
        {
          'bg-[#e7e0ec]': isSelected,
          'bg-white': !isSelected
        },
        className
      )}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        flexShrink: 0,
        borderRadius: '12px',
        boxShadow: 'none'
      }}
      onClick={() => handleSelect && handleSelect()}
    >
      <CardContent>
        <Typography variant="subtitle1" sx={{ ...useTextStyles.titleLarge }}>
          {title}
        </Typography>

        <Typography variant="subtitle2" sx={{ ...useTextStyles.bodyMedium }}>
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  )
}
